import React from 'react';
import { useTranslation } from 'react-i18next';
import { ghostButtonClass, inputClass } from '../../pages/picture-ai/usePictureAi';

/**
 * Rules an administrator writes on top of the ready-made ones.
 *
 * Deliberately not the compliance grid: there is nothing blocking or non-blocking here, and an
 * empty list is a perfectly good configuration as long as one standard rule is ticked. Reusing that
 * grid put a "blocking" checkbox and an "at least one criterion is required" warning in front of
 * someone who had already ticked two rules above.
 */
const RuleList = ({ value = [], onChange, disabled }) => {
  const { t } = useTranslation();
  const rules = Array.isArray(value) ? value : [];

  const update = (index, patch) => onChange(rules.map((rule, position) => position === index ? { ...rule, ...patch } : rule));
  const remove = (index) => onChange(rules.filter((_, position) => position !== index));
  const add = () => onChange([...rules, { label: '', description: '' }]);

  return (
    <div className="space-y-2">
      {rules.map((rule, index) => (
        <div key={rule.key || `new-${index}`} className="rounded-xl border border-gray-200 p-3 dark:border-gray-700">
          <div className="flex items-start gap-3">
            <div className="flex-1 space-y-2">
              <input
                className={inputClass} value={rule.label || ''} disabled={disabled}
                placeholder={t('Rule name, e.g. Box to empty')}
                onChange={event => update(index, { label: event.target.value })}
              />
              <input
                className={`${inputClass} text-xs`} value={rule.description || ''} disabled={disabled}
                placeholder={t('What the model should look for on the picture')}
                onChange={event => update(index, { description: event.target.value })}
              />
            </div>
            <div className="flex shrink-0 flex-col items-end gap-2">
              {/* The key is shown and never edited: it is what keeps two analyses comparable once a
                  label has been reworded. */}
              {rule.key && <code className="text-[11px] text-gray-400">{rule.key}</code>}
              <button
                type="button" disabled={disabled} onClick={() => remove(index)}
                className="text-xs text-red-600 hover:underline disabled:opacity-50"
              >
                {t('Remove')}
              </button>
            </div>
          </div>
        </div>
      ))}

      <button type="button" className={ghostButtonClass} disabled={disabled} onClick={add}>
        {t('Add a rule')}
      </button>
    </div>
  );
};

export default RuleList;
